import { useMutation, useQueryClient } from "@tanstack/react-query";

export default function useGenerateCandidateSummary(candidateId) {
  const client = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      const res = await fetch(`/api/candidates/${candidateId}/summary`, {
        method: "POST",
      });
      if (!res.ok) {
        const body = await res.json().catch(() => ({}));
        throw new Error(body?.error || "Failed to generate summary");
      }
      return res.json();
    },
    onSuccess: () => {
      client.invalidateQueries({ queryKey: ["candidateDetails", candidateId] });
    },
  });
}
